import React from "react";
import TableSPV from "../../../components/TableUserSPV.component";
import ButtonBottomRight from "../../../components/ButtonBottomRight.component";
import Jumbotron from "../../../components/Jumbotron.component";

import SEO from "../../SEO";


const MainMenu = () => {

  return (
    <div style={{height:"500px"}}>
      <SEO title="Supervisor" description="User Panel" content="User Panel"  />
     <Jumbotron description="Welcome to supervisor configuration. Here you can create, read, update and delete planner and worker user."/>
      <TableSPV />
      <ButtonBottomRight />
    </div>
  );
};


export default MainMenu;
